import {Pipe, PipeTransform} from "@angular/core";
import { YesNoEnum }         from '@shared/enums/yesNo.enum';
import {getAge}              from "@shared/helper/DateHelper";

@Pipe ({standalone: true, name: "showInfoPipe"})
export class ShowInfoPipePipe implements PipeTransform {
  transform (dateDeNaissance: Date): string {
    let showInfo = 'DO_NOT_SHOW_INFO';
    if(dateDeNaissance) {
      showInfo = 'SHOW_INFO';
      let age  = getAge (dateDeNaissance) as any;
      const ageParsed = parseInt (age, 10);
      if(ageParsed < 18 || ageParsed >= 85) {
        showInfo = 'ALERT_INFOS';
      }
    }

    return showInfo;
  }
}
